var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIreland(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1493_1055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.96802 3C2.43758 3 1.92888 3.21071 1.5538 3.58579C1.17873 3.96086 0.968018 4.46957 0.968018 5L0.968018 14C0.968018 14.5304 1.17873 15.0391 1.5538 15.4142C1.92888 15.7893 2.43758 16 2.96802 16H6.96802V3H2.96802Z",
    fill: "#169B62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.96802 3H12.968V16H6.96802V3Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.968 3H12.968V16H16.968C17.4985 16 18.0072 15.7893 18.3822 15.4142C18.7573 15.0391 18.968 14.5304 18.968 14V5C18.968 4.46957 18.7573 3.96086 18.3822 3.58579C18.0072 3.21071 17.4985 3 16.968 3Z",
    fill: "#FF883E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1493_1055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.968018 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIreland);
export default __webpack_public_path__ + "static/media/ireland.6780aa2c8ce806b72b49716c71591550.svg";
export { ForwardRef as ReactComponent };